import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { BaseResponse } from 'src/types'
import { z } from 'zod'
import { SistemaTipo } from "../../../../../types/enum/enum"
import { HttpOperacionInforme } from "../../../api/httpOperacionInforme"
import {
    OperacionLCSLHPTITablaValorUpdate,
    OperacionLCSLHPTITablaValorVista,
    OperacionLCSLHPTIInsert,
    schemaOperacionLCSLHPTITablaValorUpdate,
    schemaOperacionLCSLHPTITablaValorVista,
    schemaOperacionLCSLHPTIInsert,
    OperacionLCSLHPTITablaValorVistaInicial,
    schemaOperacionLCSLHPTITablaValorVistaInicial,
    OperacionLCSLHPTITablaValorHistoricoGrupo,
    schemaOperacionLCSLHPTITablaValorHistoricoGrupo,
    FormUpdateLCSLHPTITablaValores,
    schemaFormUpdateLCSLHPTITablaValores
} from '../types/dto'
import { OperacionLCSLHPTI, schemaOperacionLCSLHPTI } from '../types/types'

export const getEndpoint = (url = '') => `operaciones/lcslhpti${url}`

export const HttpLCSLHPTI = {
    get: (idOperacion: number): Promise<OperacionLCSLHPTI> => {
        return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}`))
            .then(response => {
                const parsed = schemaOperacionLCSLHPTI.safeParse(response)
                if (!parsed.success) {
                    console.error('Error de validación:', parsed.error.issues)

                    return Promise.reject(new Error('Error de validación.'))
                }

                return parsed.data
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    post: (operacion: OperacionLCSLHPTIInsert): Promise<BaseResponse> => {
        const parsed = schemaOperacionLCSLHPTIInsert.safeParse(operacion)
        if (!parsed.success) {
            console.error('Error de validación:', parsed.error.issues)

            return Promise.reject(new Error('Error de validación.'))
        }

        return HttpAxiosRequest.post(getEndpoint(), parsed.data)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    getTablaValoresInicial: (sinCodPais: number): Promise<OperacionLCSLHPTITablaValorVistaInicial[]> => {
        const url = getEndpoint(`/0/tabla-valores/inicial/${sinCodPais}`);
        const schemaResponse = z.array(schemaOperacionLCSLHPTITablaValorVistaInicial);

        return HttpAxiosRequest.get(url)
            .then(response => {
                const parsed = schemaResponse.safeParse(response);
                if (!parsed.success) {
                    console.error('Error de validación en getTablaValoresInicial:', parsed.error.issues);

                    return Promise.reject(new Error('Error de validación.'));
                }

                return parsed.data;
            })
            .catch(error => {
                console.error('Error de red en getTablaValores:', error);

                return Promise.reject('Error de red.');
            });
    },

    getTablaValores: (idOperacion: number): Promise<OperacionLCSLHPTITablaValorVista[]> => {
        const url = getEndpoint(`/${idOperacion}/tabla-valores`);
        const schemaResponse = z.array(schemaOperacionLCSLHPTITablaValorVista);

        return HttpAxiosRequest.get(url)
            .then(response => {
                const parsed = schemaResponse.safeParse(response);
                if (!parsed.success) {
                    console.error('Error de validación en getTablaValores:', parsed.error.issues);

                    return Promise.reject(new Error('Error de validación.'));
                }

                return parsed.data;
            })
            .catch(error => {
                console.error('Error de red en getTablaValores:', error);

                return Promise.reject('Error de red.');
            });
    },

    updateValor: (idOperacion: number, idCodTablaValor: number, valorUpdate: OperacionLCSLHPTITablaValorUpdate): Promise<BaseResponse> => {
        const parsed = schemaOperacionLCSLHPTITablaValorUpdate.safeParse(valorUpdate);
        if (!parsed.success) {
            console.error('Error de validación de entrada en updateValor:', parsed.error.issues);

            return Promise.reject(new Error('Error de validación.'));
        }

        const url = getEndpoint(`/${idOperacion}/tabla-valores/valores/${idCodTablaValor}`);

        return HttpAxiosRequest.put(url, parsed.data)
            .then(response => {
                return Promise.resolve(response);
            })
            .catch(error => {
                console.error('Error de red en updateValor:', error);

                return Promise.reject('Error de red.');
            });
    },

    getTablaValoresHistorico: (idOperacion: number): Promise<OperacionLCSLHPTITablaValorHistoricoGrupo[]> => {
        const url = getEndpoint(`/${idOperacion}/tabla-valores/historico`);
        const schemaResponse = z.array(schemaOperacionLCSLHPTITablaValorHistoricoGrupo);

        return HttpAxiosRequest.get(url)
            .then(response => {
                const parsed = schemaResponse.safeParse(response);
                if (!parsed.success) {
                    console.error('Error de validacion en getTablaValoresHistorico:', parsed.error.issues);
                    return Promise.reject(new Error('Error de validacion en el historico.'));
                }

                return parsed.data;
            })
            .catch(error => {
                console.error('Error de red en getTablaValoresHistorico:', error);
                return Promise.reject('Error de red al obtener el historial.');
            });
    },

    updateTablaValores: (idOperacion: number, datos: FormUpdateLCSLHPTITablaValores): Promise<BaseResponse> => {
        const parsed = schemaFormUpdateLCSLHPTITablaValores.safeParse(datos);
        if (!parsed.success) {
            console.error('Error de validación en updateTablaValores:', parsed.error.issues);
            return Promise.reject(new Error('Los datos ingresados no son válidos.'));
        }

        const url = getEndpoint(`/${idOperacion}/tabla-valores`);

        return HttpAxiosRequest.put(url, parsed.data)
            .then(response => {
                return Promise.resolve(response);
            })
            .catch(error => {
                console.error('Error de red en updateTablaValores:', error);
                return Promise.reject('Error al intentar guardar los cambios.');
            });
    },

    descargarInforme: (idOperacion: number): Promise<any> =>
        HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.LCSLHPTI),

} as const